import React from 'react'
import { callCenterPhoneNumber } from '@mobi/utils'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { MainContainer } from '@core/Components/Containers'
import { List, ListItem, ListLink } from '@core/Components/List'
import { FeedbackForm } from './Components/FeedbackForm/FeedbackForm'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { useObservableImmutable } from '@core/Utils/hooks'

export const ContactUsPage = (): JSX.Element | null => {
  const { accountNumber, isLoggedIn } = useObservableImmutable(userAccountState$, [
    'accountNumber',
    'isLoggedIn',
  ])
  const shouldEnableFeedbackForm = isLoggedIn && !!accountNumber

  return (
    <MainContainer testId='contact-us-page'>
      <PageHeader title='Contact Us' />

      <h3>Customer Service</h3>
      <List>
        <ListItem>
          <ListLink to={callCenterPhoneNumber}>1300 36 36 88</ListLink>
        </ListItem>
      </List>

      <h3>1300BETLIVE</h3>
      <List>
        <ListItem>
          <ListLink to='tel:1300238548'>1300 23 85 48</ListLink>
        </ListItem>
      </List>

      <h3>Betting</h3>
      <List>
        <ListItem>
          <ListLink to='tel:132369'>13 23 69</ListLink>
        </ListItem>
      </List>

      <h3>Email</h3>
      <List>
        <ListItem>
          <ListLink to='mailto:ContactUs@tabtouch.com.au'>ContactUs@tabtouch.com.au</ListLink>
        </ListItem>
      </List>

      {shouldEnableFeedbackForm && (
        <>
          <h3>Feedback</h3>
          <FeedbackForm accountNumber={accountNumber} />
        </>
      )}
    </MainContainer>
  )
}
